import React from "react"
import { useTranslation } from "react-i18next"

import { exists } from "shared/lib/exists"
import { IconSize } from "shared/types/Icon"
import { ProductInformation } from "shared/types/__generated__/graphql"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { PRODUCT_POSITION_TABLE_ADDONS_HEADER_ID } from "widgets/product-position-table/ProductPositionTableHeader"

import { ProductPositionTableCell } from "../../ProductPositionTableCell"
import { ProductPositionRowAddonsTooltip } from "../product-position/ProductPositionRowAddonsTooltip"
import { ProductPositionRowCellProps } from "../product-position/ProductPositionTableProductPositionRowView"

interface ProductPositionRowAddonsCellProps
  extends ProductPositionRowCellProps {
  productInformation: ProductInformation | null | undefined
}

export const ProductPositionRowAddonsCell = React.memo(
  React.forwardRef(
    (
      { productInformation, ...rest }: ProductPositionRowAddonsCellProps,
      ref: React.ForwardedRef<HTMLDivElement>
    ) => {
      const { t } = useTranslation()

      const hasAddons =
        exists(productInformation?.addons?.length) &&
        productInformation?.addons?.length !== 0

      return (
        <ProductPositionTableCell
          aria-labelledby={PRODUCT_POSITION_TABLE_ADDONS_HEADER_ID}
          className="addons"
          data-testid="addons-cell"
          ref={ref}
          tooltip={
            hasAddons ? (
              <ProductPositionRowAddonsTooltip
                productInformation={productInformation}
              />
            ) : null
          }
          {...rest}
        >
          {hasAddons ? (
            <Icon name={IconName.PUZZLE} size={IconSize.SMALL} />
          ) : (
            <div className="visually-hidden">
              {t("Product.Configuration.Addon.NoneSelected")}
            </div>
          )}
        </ProductPositionTableCell>
      )
    }
  )
)
